var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0275B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.996 19.9966V19.9959H20V14.1279C20 11.2572 19.3818 9.0459 16.0245 9.0459C14.4105 9.0459 13.3274 9.93123 12.8852 10.7706H12.8385V9.3139H9.65527V19.9959H12.9699V14.7066C12.9699 13.3139 13.234 11.9672 14.9594 11.9672C16.6594 11.9672 16.6847 13.5566 16.6847 14.7959V19.9966H19.996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26465 9.31366H7.58329V19.9957H4.26465V9.31366Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91867 3.99658C4.85759 3.99658 3.99658 4.85725 3.99658 5.91792C3.99658 6.97859 4.85759 7.85726 5.91867 7.85726C6.97976 7.85726 7.84076 6.97859 7.84076 5.91792C7.8401 4.85725 6.97909 3.99658 5.91867 3.99658V3.99658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtLinkedin);
export default __webpack_public_path__ + "static/media/bt_linkedin.d8b983080abfa50c2b1c5d3d274be001.svg";
export { ForwardRef as ReactComponent };